import './teamplayevents/style';
import FormStructure from './teamplayevents/form_structure';

export default FormStructure;